import { ElementRef } from '@angular/core';

/**
 * This calculates the correct area for the scrollable table.
 * Make sure that the parent element to the table component has a css position set to relative, absolute or fixed.
 * @param hasPagination
 * @param scrollScale -- this is depreacated
 * @param el -- ElementRef of the table component
 */
export function getScrollHeight(
  hasPagination: boolean,
  scrollScale: string | undefined,
  el: ElementRef,
  additionalOffset = 0
) {
  // const targetEl = el.nativeElement.querySelector('p-table');
  const targetEl = el.nativeElement.offsetParent;
  if (!targetEl) {
    console.warn(
      'getScrollHeight: No offset parent found for the table component. Ensure that the parent element exists and has a css position set to relative, absolute or fixed.',
      new Error().stack
    );
    return 0;
  }
  const rect = targetEl.getBoundingClientRect();
  /*const header = el.nativeElement.querySelector('.ui-table-scrollable-header');
  if (header) {
    console.log('Header height:', header.clientHeight);
  }*/
  const headerHeight = 106;
  const paginationOffset = hasPagination ? 50 : 0;
  const windowHeight = window.innerHeight;
  const margin = 20;
  const result =
    windowHeight -
    (rect.top + headerHeight + paginationOffset + margin + additionalOffset);

  // TODO: What is this for?
  /*    if (window.innerWidth < 1500) {
        height -= 25;
    }*/
  return result;
}
